import React, { FC } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Button, Result } from "antd";

import { brand } from "../../theme/brands";
import { isNativeApp } from "../../native/native";

interface Props {}

const ThankYou: FC<Props> = (props) => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const cancelled = searchParams.get("cancelled") === "true";
  const bookingRef = searchParams.get("ref");

  // Stripe landed an APP checkout on the public site (app=1) but the universal
  // link didn't reopen the app — offer the custom-scheme jump back. iOS won't
  // auto-open apps from same-domain/redirect navigations, but a user tap on a
  // custom scheme always works.
  const fromApp = searchParams.get("app") === "1" && !isNativeApp();
  const returnToApp = fromApp && (
    <Button
      type="primary"
      key="return-app"
      href={`runningmalta://thankyou?${searchParams.toString()}`}
    >
      Return to the Running Malta app
    </Button>
  );

  if (cancelled) {
    return (
      <div className="max-w-xl mx-auto px-4 my-8 md:my-12">
        <Result
          className="bg-white rounded-2xl shadow-sm"
          status="error"
          title="Payment Failed or Cancelled!"
          subTitle={
            <>
              Please retry registration. If the problem persists, please contact us on our FB Events Page or email (
              <a href={`mailto:${brand.supportEmail}`}>{brand.supportEmail}</a>).
            </>
          }
          extra={[
            returnToApp || (
              <Button type="primary" key="console" onClick={() => navigate("/")}>
                Go to Events
              </Button>
            ),
          ]}
        />
      </div>
    );
  } else {
    return (
      <div className="max-w-xl mx-auto px-4 my-8 md:my-12">
        <Result
          className="bg-white rounded-2xl shadow-sm"
          status="success"
          title="Thank you for registering!"
          subTitle={
            <>
              Your registration has been received and payment is being processed. You should be receiving an email
              confirmation. Please follow our FB Events Page for any updates. We will be sending a final email with all
              the details a few days before the event.
              {bookingRef && (
                <div className="mt-3 text-base">
                  Your booking reference: <b>{bookingRef}</b> — quote this in any correspondence.
                </div>
              )}
            </>
          }
          extra={[
            returnToApp || (
              <Button type="primary" key="console" onClick={() => navigate("/")}>
                Back to Events
              </Button>
            ),
          ]}
        />
      </div>
    );
  }
};

export default ThankYou;
